import { useState, useEffect, useCallback, useMemo } from "react";
import {
  getMediaItemIdentifier,
  getValidMediaUrls,
  isCarouselItem,
} from "../utils/mediaUrlsAnalysis";

export const useInternalMediaUrls = (mediaUrls) => {
  const [internalMediaUrls, setInternalMediaUrls] = useState([]);
  const [loaderProgress, setLoaderProgress] = useState(0);

  useEffect(() => {
    const safeMediaUrls = getValidMediaUrls(mediaUrls);

    setInternalMediaUrls((prevState) => {
      const safePrevState = prevState.filter(
        (item) => item != null && item.url
      );

      const prevStateMap = new Map(
        safePrevState.map((item) => [getMediaItemIdentifier(item), item])
      );

      const hasNewItems = safeMediaUrls.some(
        (mediaUrl) => !prevStateMap.has(getMediaItemIdentifier(mediaUrl))
      );

      if (hasNewItems) {
        setLoaderProgress(0);
      }

      return safeMediaUrls.map((mediaUrl) => {
        const identifier = getMediaItemIdentifier(mediaUrl);
        const existingItem = prevStateMap.get(identifier);

        if (existingItem) {
          return {
            ...existingItem,
            ...mediaUrl,
            isAnalyzing: existingItem?.isAnalyzing,
          };
        }

        return {
          ...mediaUrl,
          isAnalyzing: false,
        };
      });
    });
  }, [mediaUrls]);

  const validMediaUrls = useMemo(
    () =>
      internalMediaUrls.filter(
        (item) => item != null && (item.url || isCarouselItem(item))
      ),
    [internalMediaUrls]
  );

  const onChangeData = useCallback((data) => {
    if (!data?.url) return;
    const url = data.url;
    setInternalMediaUrls((prevState) => {
      const index = prevState.findIndex((item) => item?.url === url);
      if (index === -1) return prevState;
      const newState = [...prevState];
      newState[index] = data;
      return newState;
    });
  }, []);

  return {
    validMediaUrls,
    onChangeData,
    loaderProgress,
    setLoaderProgress,
  };
};
